import { Controller } from "@hotwired/stimulus"

// Reloads the ship-from choices whenever a new vendor is picked.
export default class extends Controller {
  static targets = ["output"]
  static values = { url: String }

  load(event) {
    const url = new URL(this.urlValue, window.location.href)
    url.searchParams.set("new_origin_id", event.detail.value || "")

    fetch(url, { headers: { "Accept": "text/html" } })
      .then(response => response.text())
      .then(html => { this.outputTarget.innerHTML = html })
  }
}
